import { createRouter, createWebHistory } from 'vue-router'
import { registerRouter } from '~/router/router'
import routes from './routes'

const router = createRouter({
  routes,
  // Leave this as is and make changes in quasar.conf.js instead!
  // quasar.conf.js -> build -> vueRouterMode
  // quasar.conf.js -> build -> publicPath
  history: createWebHistory(import.meta.env.VUE_ROUTER_BASE),

  scrollBehavior: () => ({ left: 0, top: 0 }),
})

registerRouter(router)

export default router
